

import React, {useState, useContext, useRef} from "react"
import { Grid, FormHelperText, TextField, InputAdornment, Divider, Select, MenuItem, Paper, FormControlLabel, Checkbox } from "@material-ui/core"
import { BrowserView, MobileView } from "react-device-detect"
import FlexView from "react-flexview/lib"
import { Controller, useForm } from 'react-hook-form'
import { ReactComponent as CompanyLogoSvg } from '../../../assets/company-logo.svg';
import { ReactComponent as CameraIconSvg } from '../../../assets/camera_add.svg';
import { ReactComponent as CameraChangeSvg } from '../../../assets/change-photo.svg';
import { DatePicker } from "@material-ui/pickers"
import { isOver18, awaitWithLoading } from "../../../services/utils"
import DateRangeIcon from '@material-ui/icons/DateRange';
import { SessionContextStore } from "../../../context/SessionContext"
import { OptionalTag } from "../../Core/OptionalTag"
import { FirebaseService, FirebaseConfigKey } from "../../../services/FirebaseService"
import { EventEmitterService, EventKey } from "../../../services/EventEmitterService"
import '../UserProfile.scss'
import { ACTIONS, UserProfileContextStore } from "../../../context/UserProfileContext"
import { Action } from "../../../models/Action"
import UserProfileModel from "../../../models/user-models/UserProfileModel"
import { SessionService } from "../../../services/SessionService"
import { UserApi } from "../../../api/user.api"
import { SkyElementHoverPopover } from "../../Core/Popover/SkyPopover"
import { ProfilePicturePopover } from "../../Core/Popover/ProfilePicturePopover"
import { useLocation } from "react-router-dom"
import { ProposalSessionContextStore } from "../../../context/ProposalSessionContext"
import {EMAIL_REGEX} from '../../../Constants'
import BrokerConfigService from "../../../services/BrokerConfigService"
const dayjs = require('dayjs');
const generalPhoneNumberRegex = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;

export const UserSection = (props) => {
    const location = useLocation()
    const context = useContext(UserProfileContextStore)
    const {setError} = useContext(UserProfileContextStore);
    const sessionContext = useContext(SessionContextStore)
    const { register, watch, triggerValidation, setValue, errors, control, getValues } = useForm(SessionService.isLoggedIn() ? 
        {
            defaultValues: {
                fname: sessionContext.user.firstName,
                lname: sessionContext.user.lastName,
                // company_name: sessionContext.user.company,
                dob: sessionContext.user.dateOfBirth,
                phone_number: sessionContext.user.phoneNumber,
                email: sessionContext.user.email,
            },
            mode: 'onChange'
        } : { mode: 'onChange' })
    const [img, setImg] = useState(sessionContext.user.profilePicture)
    const profilePicture = useRef(null) 
    const lnameWatch = watch('lname', sessionContext.user.lastName)
    const fnameWatch = watch('fname', sessionContext.user.firstName)
    // const companyNameWatch = watch('company_name', sessionContext.user.company)
    const phoneNumberWatch = watch('phone_number', sessionContext.user.phoneNumber)
    const email = watch('email', sessionContext.user.email)
    // const dobCheckboxWatch = watch('dob_checkbox', isOver18(sessionContext.user.dateOfBirth))
    const validatePhoneNumber = phoneNumber => !phoneNumber || generalPhoneNumberRegex.test(phoneNumber);
    const validateEmail = email => !email || EMAIL_REGEX.test(email);
    const uploadProfilePicture = () => profilePicture.current.click()

    const onProfilePictureSelected = async (event) => {
        setImg(URL.createObjectURL(event.target.files[0]))
        let res = await awaitWithLoading(UserApi.saveProfilePicture(event.target.files[0]))
        if(res.ok) {
            EventEmitterService.dispatch(EventKey.USER_PROFILE_IMAGE_UPDATED, { url: res.data.image_url })
            EventEmitterService.dispatch(EventKey.ShowSuccess, {title: 'Picture saved successfully'})
        }
        else {
            EventEmitterService.dispatch(EventKey.ShowError, res)
        }
    }


    React.useEffect(() => {
        let id = EventEmitterService.subscribe(EventKey.USER_PROFILE_SAVE, async () => {
            let valid = await triggerValidation()
            if(valid) {
                context.dispatch(new Action(ACTIONS.SAVE_USER_INFO, getValues()))
            }
            else {
                setError("Check for required fields/invalid data")
            }
        })

        return function cleanup() {
            EventEmitterService.unsubscribe(EventKey.USER_PROFILE_SAVE, id)
        }
    }, [])

    React.useEffect(() => {
        setValue('fname', sessionContext.user.firstName)
        setValue('lname', sessionContext.user.lastName)
        //setValue('company_name', sessionContext.user.company)
        setValue('phone_number', sessionContext.user.phoneNumber)
        setValue('email', sessionContext.user.email)
        //setImg(sessionContext.user.profilePicture)
    }, [sessionContext.user])

    return (
        <React.Fragment>
            <BrowserView>
                <div className="text-title blue bold">Insured Details</div>
                <Divider />
                <div className="text-body gray margin-bottom-basic">This name will appear on your certificate of insurance and policy</div>
                <Grid container spacing={2}>
                    {/* <Grid item>
                        <div className="company-logo-container" onClick={uploadProfilePicture}>
                        <SkyElementHoverPopover popOver={<ProfilePicturePopover />}>
                            {!img ? 
                            <React.Fragment>
                                <CompanyLogoSvg />
                                <div className="company-logo-text gray bold text-body">Company Logo</div>
                                </React.Fragment>
                            : <img className="company-logo-img" src={img}/>}
                            </SkyElementHoverPopover>

                            <div className="camera-box clickable" >
                                {!img ? <CameraIconSvg /> : <CameraChangeSvg />}
                            </div>
                        </div>
                    </Grid> */}
                    <Grid item xs={12} md>
                        <FlexView>
                            <TextField 
                                InputLabelProps={{ shrink: !!fnameWatch }} 
                                fullWidth variant="outlined" 
                                label="First name" 
                                name="fname" 
                                autoComplete="given-name" 
                                autoFocus={!BrokerConfigService.isNetworkBroker()} 
                                inputRef={register({
                                    required: 'Required', 
                                    validate: value => value.trim() !== '' || 'Required'
                                })}
                                helperText={errors.fname ? errors.fname.message : ''}
                                error={!!errors.fname} />
                            <TextField 
                                InputLabelProps={{ shrink: !!lnameWatch }} 
                                fullWidth variant="outlined" 
                                className="margin-left-basic" 
                                label="Last name" 
                                name="lname" 
                                autoComplete="family-name" 
                                inputRef={register({
                                    required: 'Required', 
                                    validate: value => value.trim() !== '' || 'Required'
                                })}
                                helperText={errors.lname ? errors.lname.message : ''}
                                error={!!errors.lname} />
                        </FlexView>
                        <FlexView className="margin-top-basic">
                            <div>

                            <TextField InputLabelProps={{ shrink: !!phoneNumberWatch }} 
                                fullWidth variant="outlined" 
                                label="Phone number" 
                                name="phone_number" 
                                inputRef={register({validate: validatePhoneNumber, required: true})}
                                autoComplete="tel" 
                                error={!!errors.phone_number}
                                helperText={!!errors.phone_number? 'Invalid phone number' : ''}
                                />
                                <div className="margin-top-6">
                                    <span style={{'fontSize': '12px', color: '#77869e'}}>By providing your phone number, you agree to receive text messages from Skywatch. Message and data rates may apply. We never sell your data or share personal details in any promotional way.</span>
                                </div>
                                </div>
                            {/* <TextField InputLabelProps={{ shrink: !!companyNameWatch }} 
                                fullWidth variant="outlined" 
                                className="margin-left-basic" 
                                label="Company name" 
                                name="company_name" 
                                InputProps={{endAdornment: <InputAdornment position="start"> <OptionalTag /> </InputAdornment>}} 
                                inputRef={register} error={!!errors.company_name} /> */}
                            <TextField InputLabelProps={{ shrink: !!email }} 
                                fullWidth variant="outlined"
                                className="margin-left-basic" 
                                disabled={SessionService.isLoggedIn()}
                                label="Email" 
                                name="email" 
                                inputRef={register({validate: validateEmail, required: true})}
                                error={!!errors.email}
                                helperText={!!errors.email? 'Invalid email' : ''}
                                />
                        </FlexView>
                    </Grid>
                </Grid>
            </BrowserView>
            <MobileView>
                    <div>
                        {/* <FlexView vAlignContent={'center'}>
                            <div className="company-logo-container">
                                {!img ? 
                                <React.Fragment>
                                    <CompanyLogoSvg />
                                    <div className="company-logo-text gray bold text-body">Company Logo</div>
                                    </React.Fragment>
                                : <img className="company-logo-img" src={img}/>}

                                <div className="camera-box clickable" onClick={uploadProfilePicture}>
                                    {!img ? <CameraIconSvg /> : <CameraChangeSvg />}
                                </div>
                            </div>
                            <div>
                                <Paper elevation={3} className="logo-popover-container">
                                    <div className="logo-popover-inner">
                                        <div className="text-small black">Your logo will appear on your certificate of insurance</div>
                                    </div>
                                </Paper>
                                <FlexView className="margin-top-medium space-between logo-popover-container" vAlignContent={'center'}>
                                    <div onClick={uploadProfilePicture} className="text-small blue underline clickable">Upload Photo</div>
                                    <OptionalTag />
                                </FlexView>
                            </div>
                        </FlexView> */}
                        <div className="text-small gray margin-bottom-basic margin-top-basic">This name will appear on your certificate of insurance and policy</div>
                        <TextField 
                                InputLabelProps={{ shrink: !!fnameWatch }} 
                                fullWidth variant="outlined" 
                                className="margin-top-small" 
                                label="First name" 
                                name="fname" 
                                autoComplete="given-name" 
                                autoFocus={!BrokerConfigService.isNetworkBroker()} 
                                inputRef={register({required: true})}
                                helperText={!!errors.fname? 'Required' : ''}
                                error={!!errors.fname} />
                        <TextField 
                                InputLabelProps={{ shrink: !!lnameWatch }} 
                                fullWidth variant="outlined" 
                                className="margin-top-basic" 
                                label="Last name" 
                                name="lname" 
                                autoComplete="family-name" 
                                inputRef={register({required: true})}
                                helperText={!!errors.lname? 'Required' : ''}
                                error={!!errors.lname} />
                        <TextField 
                                InputLabelProps={{ shrink: !!email }} 
                                fullWidth variant="outlined" 
                                disabled={SessionService.isLoggedIn()} 
                                className="margin-top-basic" 
                                label="Email" 
                                name="email" 
                                autoComplete="email" 
                                inputRef={register({required: true})}
                                helperText={!!errors.email? 'Required' : ''}
                                error={!!errors.email} />
                        <TextField InputLabelProps={{ shrink: !!phoneNumberWatch }} 
                                fullWidth variant="outlined" 
                                label="Phone number" 
                                className="margin-top-basic" 
                                name="phone_number" 
                                inputRef={register({validate: validatePhoneNumber, required: true})}
                                autoComplete="tel" 
                                error={!!errors.phone_number}
                                helperText={!!errors.phone_number? 'Invalid phone number' : ''}
                                />
                        {/* <TextField InputLabelProps={{ shrink: !!companyNameWatch }} fullWidth variant="outlined" className="margin-top-basic" label="Company name" name="company_name" InputProps={{endAdornment: <InputAdornment position="start"> <OptionalTag /> </InputAdornment>}} inputRef={register} error={!!errors.company_name} /> */}
                    </div>
            </MobileView>
            <input type='file' accept="image/*" id='file' onChange={onProfilePictureSelected} ref={profilePicture} style={{display: 'none'}}/>
        </React.Fragment>
    )
}